import React from "react";

const Help = () => <div>Help Me!</div>;

export default Help;
